import { Lock } from "lucide-react";
import { Card, CardContent } from "@wa/ui";
import { useT } from "../i18n/I18nProvider";

/**
 * What an account tab shows while an operator is previewing a client's portal.
 *
 * The menu in a preview is the client's menu, whole - that is the promise of
 * "view as customer", and a preview missing six of the client's tabs answers
 * the wrong question about the layout. The SCREENS behind those tabs are a
 * different matter: the preview token names a client, not a person, so every
 * one of them (profile, security, notifications, preferences, privacy) would
 * render the signed-in OPERATOR's own account. Privacy is the sharpest case,
 * because it carries the GDPR export and the account deletion, and those are
 * `/api/account/*` routes rather than `/api/portal/*` - the preview's read-only
 * rule does not cover them.
 *
 * So the tab is drawn and the screen is not. This card is what stands in its
 * place, and it says which of the two it is, in the client's own language.
 */
export function PreviewAccountNotice({ label }: { label: string }) {
  const t = useT();
  return (
    <Card>
      <CardContent className="flex flex-wrap items-start gap-4 p-6">
        <span className="flex size-10 shrink-0 items-center justify-center rounded-full bg-muted text-muted-foreground">
          <Lock className="size-5" />
        </span>
        <div className="min-w-0 flex-1">
          <h2 className="text-lg font-semibold tracking-tight">{t("preview.accountTitle", { tab: label })}</h2>
          <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">{t("preview.accountBody")}</p>
        </div>
      </CardContent>
    </Card>
  );
}
